<script>
export default {
  mounted() {
    window.voiceSearch = (result) => {
      window.location.href = `${process.env.VUE_APP_BASE_CUSTOM_SCHEME}/open/stop_voice_input`
      this.$store.commit('search/setSearchKeyword', result)
      this.$store.commit('modal/setShowingVoiceSearchModal', false)
    }
    window.checkReservationStatus = (name, registNumber, numberOfPersons, displayTime) => {
      this.$store.commit('reservation/setReserveInfo', {
        name,
        registNumber,
        numberOfPersons,
        displayTime,
      })
    }
  },
  render(h) {
    return h() // avoid empty template warning message
  },
}
</script>
